var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHammer = function SvgHammer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.11 5.192a3.136 3.136 0 0 1 4.434 0l2.85 2.849a.45.45 0 0 1 0 .636.893.893 0 1 0 1.262 1.263.45.45 0 0 1 .637 0l.95.95a.45.45 0 0 1 0 .636l-3.8 3.799a.45.45 0 0 1-.636 0l-.95-.95a.45.45 0 0 1 0-.636.893.893 0 1 0-1.262-1.263l-6.908 6.913a1.793 1.793 0 0 1-2.536-2.536L11.06 9.94l.95-.95a.893.893 0 0 0 0-1.262l-1.9-1.9a.45.45 0 0 1 0-.636m3.207 6.37a1.794 1.794 0 0 1 2.455 2.455l.353.353 3.163-3.162-.354-.353a1.794 1.794 0 0 1-2.455-2.456l-2.571-2.57a2.24 2.24 0 0 0-2.812-.287l1.549 1.55c.7.7.7 1.835 0 2.535l-.632.631zm-1.94-.667-6.59 6.594a.893.893 0 0 0 1.263 1.263l6.59-6.594z",
    clipRule: "evenodd"
  })));
};
export default SvgHammer;